import React from "react";
import styled from "styled-components";
import { useAppContext } from "./useAppContext";

const Container = styled.div`
  & * {
    text-decoration: none;
  }
`;

const TeamItem = styled.li`
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-column-gap: 10px;
  padding: 10px;
  border: 1px solid lightgray;
  margin-bottom: 10px;
  background-color: ${props => (props.active ? "whitesmoke" : "white")};

  &:hover {
    background-color: whitesmoke;
  }
`;

const Title = styled.div``;

export default ({ team }) => {
  const { removeTeam, setTeamTitle } = useAppContext();

  const onEditClicked = () => {
    const title = prompt("Change team title:", team.title);
    if (title) {
      setTeamTitle(team.id, title);
    }
  };

  const onDeleteClicked = () => {
    const result = window.confirm("Are you sure you want to delete this team?");
    if (result) {
      removeTeam(team.id);
    }
  };

  return (
    <Container>
      <TeamItem>
        <Title>{team.title}</Title>
        <button onClick={onEditClicked}>Edit</button>
        <button onClick={onDeleteClicked}>Delete</button>
      </TeamItem>
    </Container>
  );
};
